import { gql } from "@apollo/client";

const FEATURED_CLIP_FIELDS = gql`
  fragment FeaturedClipFields on Clip {
    title
    thumbnailUrl(style: OVERLAY)
    url(orientation: LANDSCAPE)
    shareId
    views
    createdAt
    user {
      internalId
      avatarUrl
      username
    }
  }
`;

export const HOMEPAGE_FEATURED = gql`
  ${FEATURED_CLIP_FIELDS}
  query HomepageFeatured {
    top5: clipsNew(
      first: 1
      sort: LATEST
      filters: {
        clipProperties: [
          { key: "INTERNAL_FEATURED", value: "TOP_5", category: "TOP_5" }
        ]
      }
    ) {
      nodes {
        ...FeaturedClipFields
      }
    }
    cotd: clipsNew(
      first: 1
      sort: LATEST
      filters: { clipProperties: [{ key: "COTD", value: "true" }] }
    ) {
      nodes {
        ...FeaturedClipFields
      }
    }
    motw: montagesNew(
      first: 1
      sort: LATEST
      filters: { clipProperties: [{ key: "MOTW", value: "true" }] }
    ) {
      nodes {
        ...FeaturedClipFields
      }
    }
    promotions {
      name
      activeCarouselPromos {
        name
        title
        subtitle
        image
        link
        buttonCopy
        sideGradientCSS
        external
        tag
        buttonAction
        thumbnail
        experimentName
        clip {
          shareId
          cf {
            thumbnail
          }
        }
      }
    }
  }
`;
